<template>
  <component :is="icon" v-if="icon" />
  <span v-else>Error in icon</span>
</template>

<script lang="ts" setup>
import { type Component, computed, defineAsyncComponent } from 'vue'

import { type Icon, isIcon } from '../../types/icon'

const props = defineProps<{
  icon: Icon
}>()

const icon = computed<Component | undefined>(() => {
  if (!isIcon(props.icon)) {
    // eslint-disable-next-line no-console
    console.error(`Icon ${props.icon as string} not found`)
    return
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return defineAsyncComponent<Component>(async () => import(`@ui-assets/icons/${props.icon}.svg`))
})
</script>
